import { BreadcrumbService } from "src/app/angularJS/services/breadcrumbs/breadcrumb.service";
import { RailSettlementService } from "src/app/angularJS/services/rail-settlement/rail-settlement.service";
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';
import { DialogService } from 'src/app/angularJS/services/dialog/dialog.service';
import * as moment from 'moment';
import { FileBuilderService } from 'src/app/angularJS/services/file-builder/file-builder.service';
import { FileExporterService } from 'src/app/angularJS/services/file-exporting/file-exporter.service';

export class RailSettlementController {
  public static $inject = [
    'breadcrumbService',
    'railSettlementService',
    '$rootScope',
    '$state',
    '$translate',
    'ACTToolbarService',
    '$q',
    'QueryBuilder',
    'dialogService',
    'fileBuilderService',
    'fileExporterService',
    'regexPatterns'
  ];

  public paginatorData: InterACT.Interfaces.IPaginationData = {
    currentPage: 1,
    perPageCount: 15,
    totalCount: 0
  };

  public startDate = new Date().toISOString();
  public startTime = '00:00';
  public endDate = new Date(new Date().setDate(new Date().getDate() + 1)).toISOString();
  public endTime = '00:00';

  public filters = {
    status: 'ALL',
    fromDate: '',
    toDate: ''
  };
  public rssSettlementBatchStatus: string;
  public rssSettlementBatch: InterACT.Interfaces.RailSettlement.RssSettlementBatch;
  public rssSettlementBatchWithMeta: InterACT.Interfaces.IRssSettlementBatch[] = [];

  public currentLocale: string;
  public expandedItem: InterACT.Interfaces.RailSettlement.RssSettlementBatch;

  constructor(
    public breadcrumbService: BreadcrumbService,
    public railSettlementService: RailSettlementService,
    private $rootScope: InterACT.Interfaces.IActoraRootScope,
    public $state: ng.ui.IStateService,
    public $translate: ng.translate.ITranslateService,
    public ACTToolbarService: ACTToolbarService,
    private $q: ng.IQService,
    private queryBuilder: QueryBuilder,
    private dialogService: DialogService,
    private fileBuilderService: FileBuilderService,
    private fileExporterService: FileExporterService,
    public regexPatterns: { TIME: string, NUMBER: string }
  ) {
    this.activate();
  }

  private async activate() {
    this.currentLocale = this.$translate.use();

    this.ACTToolbarService.getToolbar('primary').then(async (toolbar) => {

      this.breadcrumbService.setBreadcrumbs([{
        name: 'APPORTIONMENT',
        sref: '#'
      },
      {
        name: 'RAIL_SETTLEMENT.LENNON',
        sref: '#'
      }]);
      toolbar.setTitle('RAIL_SETTLEMENT.LENNON');
    });
  }

  /**
  * A method that retrieves a given page of rss settlement batches
  * @param page the page of rss settlement batches to retrieve
  * @param perPage the amount of rss settlement batches to retrieve per page
  */
  public getData(page: number, perPage: number) {
    this.getRssSettlementBatches(page, perPage);
  }

  /**
   * A method that sends a request to perform RSS settlement
   */
  public performRssSettlement = () => {
    const [startHour, startMinute] = this.startTime.split(':');
    const [endHour, endMinute] = this.endTime.split(':');
    const rssSettlementRequest =
      this.railSettlementService.getNewRssSettlementRequest(
        moment(this.startDate).set({ "hour": Number(startHour), "minute": Number(startMinute), "seconds": 0, "milliseconds": 0 }).toISOString(),
        moment(this.endDate).set({ "hour": Number(endHour), "minute": Number(endMinute), "seconds": 0, "milliseconds": 0 }).toISOString()
      );

    this.dialogService.showDialog(
      this.$translate.instant('RAIL_SETTLEMENT_REQUEST_DIALOG.CONFIRM_SUBMIT'),
      'rail-settlement-request-dialog.html',
      {
        from: moment(this.startDate).set({ "hour": Number(startHour), "minute": Number(startMinute), "seconds": 0, "milliseconds": 0 }).format('DD MMM YYYY HH:mm'),
        to: moment(this.endDate).set({ "hour": Number(endHour), "minute": Number(endMinute), "seconds": 0, "milliseconds": 0 }).format('DD MMM YYYY HH:mm')
      },
      'rail-settlement-request-dialog'
    ).then(() => {
      this.railSettlementService.createRssSettlementRequest(rssSettlementRequest);
    });
  }

  /**
   * A method is called whenever any of the filters on this controller have changed
   */
  public onFilterChanged = () => {
    return this.getRssSettlementBatches(this.paginatorData.currentPage, this.paginatorData.perPageCount);
  };

  /**
   * A method that toggles the expansion state for the supplied RSS Settlement Batch
   * @param rssSettlementBatch the rss settlement batch to toggle the expansion for
   */
  public toggleExpansion = (rssSettlementBatch: InterACT.Interfaces.RailSettlement.RssSettlementBatch) => {
    if (!rssSettlementBatch.message) {
      return;
    }
    this.expandedItem = this.expandedItem === rssSettlementBatch ? undefined : rssSettlementBatch;
  }

  /**
   * A method that gets a page worth or rss settlement batches
   * @param page the page number to retrieve
   * @param perPage the number of rss settlement batches to retrieve per page
   */
  private getRssSettlementBatches = (page: number, perPage: number) => {
    this.$rootScope.showSpinner = true;

    if (!page) {
      page = this.paginatorData.currentPage;
    }

    if (!perPage) {
      perPage = this.paginatorData.perPageCount;
    }

    const query = this.constructQueryString();

    this.railSettlementService.getList(page, perPage, query).then((response: InterACT.Interfaces.RailSettlement.RssSettlementBatchesResponse) => {
      this.paginatorData.totalCount = response.meta.totalCount;
      this.$rootScope.showSpinner = false;
      this.rssSettlementBatchWithMeta = response.rssSettlementBatches.map(({ meta, rssSettlementBatch }) => {
        return {
          created: meta.created,
          id: rssSettlementBatch.id,
          batchId: rssSettlementBatch.batchId,
          batchTotalRecords: rssSettlementBatch.batchTotalRecords,
          status: rssSettlementBatch.status,
          message: rssSettlementBatch.message
        }
      });
    });
  };

  /**
   * A method that constructs a qParam query string based on the selected filters held on this controller
   */
  private constructQueryString() {
    var query;

    query = this.filters.status === "ALL"
      ? this.queryBuilder.openSubQuery().statusIs('SUCCESS').or().statusIs('FAILED').closeSubQuery()
      : this.queryBuilder.fieldIs('status', this.filters.status);

    if (this.filters.fromDate) {
      query.and().isGreaterOrEqualTo('created', '\'' + moment(this.filters.fromDate).set({ "hour": 0, "minute": 0, "seconds": 0, "milliseconds": 0 }).toISOString() + '\'');
    }

    if (this.filters.toDate) {
      
      query.and().isLessThanOrEqualTo('created', '\'' + moment(this.filters.toDate).set({ "hour": 23, "minute": 59, "seconds": 0, "milliseconds": 0 }).toISOString() + '\'');
    }

    query.sortBy([
      { columnName: 'created', direction: 'desc' }
    ]);

    return query.getParam();
  }

  /**
  * Requests an exported version of the rail settlement items
  * @param format the export format
  */
  public exportTo = (batchId: string) => {
    const title = this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_TITLE');
    this.$rootScope.showSpinner = true;
    this.fileBuilderService.buildExcelFile(
      '/rss-settlement-items',
      `rssSettlementBatch.link='/rss-settlement-batches/${batchId}'`,
      this.getRssSettlementItemColumns(),
      this.currentLocale,
      'CSV',
      title).then((response) => {
        this.$rootScope.showSpinner = false;
        this.fileExporterService.exportToExcel(response.data, 'CSV', title);
      });
  }

  /**
   * Returns a list of the rail settlement item columns
   * @returns the list of rail settlement item columns
   */
  public getRssSettlementItemColumns = () => {
    return [
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.ID'), key: 'id' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.BATCH_DTLS_ID'), key: 'batchDtlsId' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.CHARGE_ACCOUNT_LINK'), key: 'chargeAccountLink' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.CROSS_LONDON'), key: 'crossLondon' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.DATE_SALE'), key: 'dateSale' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.DEFAULT_CAPRI_CODE'), key: 'defaultCapriCode' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.FARE_AMOUNT'), key: 'fareAmount' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.FARE_CLASS'), key: 'fareClass' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.JOURNEYS'), key: 'journeys' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.NLC_DESTINATION'), key: 'nlcDestination' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.NLC_ORIGIN'), key: 'nlcOrigin' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.NUM_ADULTS'), key: 'numberOfAdults' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.NUM_CHILDREN'), key: 'numberOfChildren' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.REPLACED_BY'), key: 'replacedBy' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.RSS_SETTLEMENT_BATCH_LINK'), key: 'rssSettlementBatchLink' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.SINGLE_OR_RETURN'), key: 'singleOrReturn' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.STATUS'), key: 'status' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.STATUS_CODE'), key: 'statusCode' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.TICKET_TYPE'), key: 'ticketType' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.TIME_ISSUE'), key: 'timeIssue' },
      { header: this.$translate.instant('RAIL_SETTLEMENT.DOCUMENT_HEADINGS.VALIDITY_PERIOD'), key: 'validityPeriod' }
    ];
  }

  public validateSettlementDateRange = () => {
    let [startHour, startMinute] = ['', ''];
    let [endHour, endMinute] = ['', ''];

    if (this.startTime) {
      [startHour, startMinute] = this.startTime.split(':')
    }

    if (this.endTime) {
      [endHour, endMinute] = this.endTime.split(':')
    }

    const startDateTime = moment(this.startDate).set({ "hour": Number(startHour), "minute": Number(startMinute), "seconds": 0, "milliseconds": 0 }).toISOString();
    const endDateTime = moment(this.endDate).set({ "hour": Number(endHour), "minute": Number(endMinute), "seconds": 0, "milliseconds": 0 }).toISOString()
    const timeRegex = new RegExp(this.regexPatterns.TIME);

    if (!this.endDate || !this.startDate || !this.startTime || !this.endTime || startDateTime >= endDateTime || !timeRegex.test(this.startTime) || !timeRegex.test(this.endTime)) {
      return true;
    }
    return false;
  }
}
